import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import useBuildUpdateWebhookRows from './buildUpdateWebhooksRows.helper';
import { DefaultValues, ToggleValues } from './types';
import { UtilButton } from 'UI';
import { useTranslation } from 'react-i18next';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateWebhookProps = {
  defaultValues: DefaultValues;
  toggleValues: ToggleValues;
  onSubmit: () => void;
  onBack: () => void;
};
type FC = FunctionComponent<UpdateWebhookProps>;

const UpdateWebhooksReview: FC = (props: UpdateWebhookProps) => {
  const { defaultValues, toggleValues, onSubmit, onBack } = props;
  const updateWebhookRows = useBuildUpdateWebhookRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks.Update.Review' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <Formik enableReinitialize initialValues={defaultValues} onSubmit={onSubmit} validateOnChange validateOnBlur>
      {({ handleSubmit }) => {
        const updateWebhookTable: vp.TableProps = {
          name: 'update-webhook-fields',
          columns: {
            Field: { header: t('event') },
            Toggle: { header: t('enable'), align: 'left' },
            Input: { header: t('url') },
          },
          rows: updateWebhookRows.map(({ label, id, preset }) => ({
            Field: label,
            Toggle: (
              <div style={{ paddingLeft: '40px' }}>{toggleValues[id] === true ? tGlobal('yes') : tGlobal('no')}</div>
            ),
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="background"
                onBlur={() => {}}
                onChange={() => {}}
                value={defaultValues[id]}
                disabled
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box flx="col" mb="lg" gapSize="16px">
              <UtilButton iconLeft="chevron_left" size="large" onClick={onBack}>
                {tGlobal('Buttons.back')}
              </UtilButton>
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updateWebhookTable} />
            <Box width="100%" jc="fe" mt="lg">
              <Button id="webhook-submit" type="submit" label={tGlobal('Buttons.save')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default UpdateWebhooksReview;
